import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { DISTRIBUTION_COST_BY_MONTHS_GET } from 'api/query-keys';
import type { TGetDistributionCostByMonthsRes } from 'api/swagger';
import type { IDistributionCostFilter } from 'shared/stores/use-distribution-cost-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IDistributionCostFilter;
}

export const useGetDistributionCostByMonths = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IDistributionCostFilter>(qs, filters);

  return useQuery({
    queryKey: [DISTRIBUTION_COST_BY_MONTHS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetDistributionCostByMonthsRes>(
        `/v1/statistics/distribution-cost-by-months?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
